import { BuyerDisplay } from "./auction-cluster-buyer";

export class Zone {
  zoneId: number;
  locationId: number;
  name: string;
  type: number;
  isActive: boolean;
  buyers: Array<BuyerDisplay> = [];

  // displayable fields
  locationName: string;
  typeName: string;
  displayBuyerNames: string;

  // helper fields
  buyerIds: Array<number> = [];
  selectedBuyerId: number;
}
